import React, { useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
//import store from "store";
import styles from "./index.module.scss";
import { FileItemProps } from ".";
import { Upload, Button, message } from "antd";
// import { UploadOutlined } from "@ant-design/icons";
import { RcFile, UploadFile } from "antd/lib/upload";
import { waitRes } from "@/utils/axios";
import { post_upload } from "@/api/xt-user";
interface UploadProps extends BaseCompProps {
  attr?: any;
  type: number;
  fileList: FileItemProps[];
  uploadChange?(fileList: FileItemProps[], type: number): void;
}
const { useTranslation } = Hooks;
const P3Upload: React.FC<UploadProps> = ({ className, type, fileList, uploadChange }) => {
  const t = useTranslation();
  //const {isLogin} = store.user;
  const [loading, setLoading] = useState(false);

  /**useMemo */
  const isDisabled = useMemo(() => {
    if (loading) return true;
    if (type == 5) return fileList?.length >= 10;
    return fileList?.length >= 2;
  }, [loading, type, fileList]);

  /**method */
  const handleRemove = (file: UploadFile<any>) => {
    const index = fileList.findIndex((item) => item.uid == file.uid);
    fileList.splice(index, 1);
    uploadChange?.([...fileList], type);
  };
  const beforeUpload = (file: RcFile) => {
    const isLt10M = file.size / 1024 / 1024 < 10;
    const isAcceptFileType = /\.jpg|\.jpeg|\.png|\.pdf$/.test(file.name);
    if (!isLt10M) {
      message.error(t("ent.uploadFileLimit", [10]));
    } else if (!isAcceptFileType) {
      message.error(t("ent.uploadFileTypeError") || "Please upload a valid file type");
    } else {
      uploadFile(file);
    }

    return false;
  };

  const uploadFile = async (file: RcFile) => {
    setLoading(true);
    const item = {
      uid: file.uid,
      name: file.name,
      url: "",
      status: "uploading" as UploadFile["status"],
    };
    uploadChange?.([...fileList, item], type);
    const { data, err }: { data: { absolutePath: string; fileName: string }; err?: string } = await waitRes(post_upload, file);
    setLoading(false);
    if (err) {
      item.status = "error";
      uploadChange?.([...fileList, item], type);
    } else {
      item.name = data.fileName;
      item.url = data.absolutePath;
      item.status = "done";
      uploadChange?.([...fileList, item], type);
    }
  };
  return (
    <div className={cx(styles["page-account-enterprise-p3-upload"], className)}>
      <Upload disabled={loading} accept=".jpg,.jpeg,.png,.pdf" fileList={fileList} beforeUpload={beforeUpload} onRemove={handleRemove}>
        <Button disabled={isDisabled} >
          {t("ent.upload")}
        </Button>
      </Upload>
    </div>
  );
};
export default observer(P3Upload);
